/*
 * RUNTIME BRIDGE
 * La fuente editable unica es: /_AppConfig/MainCompany.js
 * El script /_AppConfig/Scripts/generate-company-config.js genera public/app-config.js
 * y este modulo consume esa configuracion ya generada desde window.__APP_CONFIG__.
 */
const runtimeCompany =
  typeof window !== "undefined" && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

export const MAIN_COMPANY = Object.freeze({ ...runtimeCompany });
